import { createApp } from '@/cryptocurrency';
import { i18nSetPublicLocale } from '@/i18n';

const { app, store } = createApp();

if (window.__INITIAL_STATE__) {
  // We initialize the store state with the data injected from the server
  store.replaceState(window.__INITIAL_STATE__);
}

i18nSetPublicLocale(store.state.language)
  .then(() => app.$mount('#cryptocurrency-app'));
